import { FrontmatterNodes } from '@/types';

export const mapFrontmatter = <T>(nodes: FrontmatterNodes): T =>
    nodes.map(({ childMarkdownRemark: { frontmatter }, ...others }) => ({ ...frontmatter, ...others })) as T;
